import React, { useState } from "react";
import { Modal, Button, Box, Grid } from "@mui/material";
import { H5 } from "./Typography";

type MyModalProps = {
  open: boolean;
  handleClose: () => void;
  handleSave: (value: any) => void;
  sipList: string[]; // Update the prop type to an array of strings
};
const dateOrdinal = (d: any) => {
  return (
    d +
    (31 == d || 21 == d || 1 == d
      ? "st"
      : 22 == d || 2 == d
      ? "nd"
      : 23 == d || 3 == d
      ? "rd"
      : "th")
  );
};

function SIPdateModel({
  open,
  handleClose,
  handleSave,
  sipList,
}: MyModalProps) {
  const handleSaveClick = () => {
    handleSave(selectedDate);
    setDateColor("#000");
    setSelectedDate(date);
  };
  const handleCloseSaveClick = () => {
    handleClose();
  };

  const [datecolor, setDateColor] = React.useState("");
  const [date, setDate] = React.useState("");
  const [selectedDate, setSelectedDate] = useState("");

  const handleDateClick = (date: any) => {
    setSelectedDate(date);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid sx={style}>
        <Box sx={header}>
          <H5
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              p: 1.5,
              color: "#ffff",
            }}
            fontWeight={"500"}
          >
            Choose SIP installment date
          </H5>
        </Box>
        <Grid container sx={{ mt: 2, p: 2, pt: 0 }} spacing={2}>
          {sipList.map((date: any, index: number) => (
            <Grid item key={index} xs={2}>
              <div
                style={{
                  backgroundColor:
                    date === selectedDate
                      ? process.env.REACT_APP_PRIMARY_COLOR
                      : "#FEF7E3",
                  padding: "8px",
                  borderRadius: "8px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleDateClick(date)}
              >
                <H5
                  fontWeight={550}
                  sx={{
                    color: date === selectedDate ? "#fff" : "#000",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  {date}
                </H5>
              </div>
            </Grid>
          ))}
        </Grid>
        <Box sx={container}>
          {selectedDate ? (
            <H5
              fontWeight={400}
              sx={{ color: "#595959", fontFamily: "'Poppins', sans-serif" }}
            >
              Installment Date {`${dateOrdinal(selectedDate)} of every month`}
            </H5>
          ) : null}

          <Box sx={buttonContainer}>
            <Button
              variant="contained"
              onClick={handleCloseSaveClick}
              sx={close}
            >
              Cancel
            </Button>
            <Button variant="contained" onClick={handleSaveClick} sx={add}>
              Submit
            </Button>
          </Box>
        </Box>
      </Grid>
    </Modal>
  );
}

export default SIPdateModel;
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    md: "30%",
    xs: "90%",
  },
  bgcolor: "background.paper",
  overflowY: "scroll",
  boxShadow: 4,

  borderRadius: 2,
  overflow: "hidden",
};
const header = {
  width: "100%",
  bgcolor: process.env.REACT_APP_PRIMARY_COLOR,
  boxShadow: 4,
};
const container = {
  pl: 2,
  pr: 2,
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  pb: 1.5,
  pt: 2,
};

const buttonContainer = {
  width: "100%",
  justifyContent: "space-between",
  flexDirection: "row",
  display: "flex",

  mt: {
    md: 2.5,
    xs: 1,
  },
};

const add = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: {
    md: "80%",
    xs: "100%",
  },
  mb: 1,
  ml: 2,
  borderRadius: 2,
};
const close = {
  background: "#fff",
  color: "#000",
  width: {
    md: "80%",
    xs: "100%",
  },
  mb: 1,
  mr: 2,
  borderRadius: 2,
};
